"use strict";

define('uikit/views/table.selected',['marionette', '../mixins/component.mixin'], function (Mn, ComponentMixin) {
  var TableSelectedView = Mn.ItemView.extend(ComponentMixin).extend({
    options: {
      visible: false,
      inverted: false
    },
    update: {
      inverted: false
    },
    template: function template() {
      return '<ui name="view" />';
    },
    _show: function _show() {
      this.view.$el.css('background-color', this._defaultColor);
    },
    _hide: function _hide() {
      this.view.$el.css('background-color', 'transparent');
    },
    getRow: function getRow() {
      return this.getOption('rowView');
    },
    getTable: function getTable() {
      return this.getRow().tableView;
    },
    onChangeInverted: function onChangeInverted() {
      if (this.view) {
        this.view.inverted = this.inverted;
      }
    },
    onFirstRender: function onFirstRender() {
      var row = this.getOption('rowView'),
        table = row.tableView,
        entered = false;
      row.on('mouseenter', function () {
        entered = true;
        this.visible = true;
      }, this).on('mouseleave', function () {
        entered = false;
        if (!row.active) {
          this.visible = false;
        }
      }, this).on('change:active', function () {
        if (!row.active && !entered) {
          this.visible = false;
        } else if (row.active && table.selection) {
          this.visible = true;
        }
      }, this).listenTo(table, 'change:selection', function () {
        if (!table.selection) {
          this.visible = false;
        } else if (entered) {
          this.visible = true;
        }
      });
      if (row.active) {
        this.visible = true;
      }
      this._defaultColor = this.view.$el.css('background-color');
    }
  });
  return TableSelectedView;
});

